import { SourceNode } from '../SourceNode';
/**
 * @category Source node
 */
export class CallbackSourceNode extends SourceNode {
  constructor(callback = () => null, options) {
    super(options);
    this.callback = callback;
  }
  onPull(options) {
    return new Promise((resolve, reject) => {
      Promise.resolve(this.callback(options)).then(output => {
        resolve(output);
      }).catch(reject);
    });
  }
}